const {h, render, Component} = require('preact');
const EmailFormDescriptionView = require('../../views/email_form/common/email_description_view')
const MerchantNameView = require('../../views/email_form/common/mechant_name_view')
const CallUsLinkView = require('../../views/common/call_us_link')
const IssueView = require('../../views/email_form/common/issue_view')
const FBInput = require('../../views/email_form/fb_input')
const EmailFormSubmitView = require('../../views/common/submit_button_view')
const Helper = require('../../../helper')
const {route} = require('preact-router')
const RecaptchaView = require('../../containers/common/recaptcha')
const UserNameInputView = require('../../views/common/user_name_view')
const ResponseTimeView = require('../../views/email_form/response_time')
const EmailAddressInputView = require('../../views/common/email_address_view')
const Web2018Helper = require('../../../helper')
const FileInputView = require('../../views/email_form/common/file_input')

class EmailFormMainView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email_description_box: '',
      email_description_box_isValid: false,
      recaptcha: false,
      email_address_box: '',
      email_address_box_isValid: false,
      user_name_box: '',
      user_name_box_isValid: false,
      file_input: null,
      file_input_isValid:false
    };
    this.setRecaptchaInstance = this.setRecaptchaInstance.bind(this);
    this.changeEmailDescriptionBoxState = this.changeEmailDescriptionBoxState.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.setReasonText = this.setReasonText.bind(this);
    this.onRecaptchaDone = this.onRecaptchaDone.bind(this);
    this.handleClosePopupEvent = this.handleClosePopupEvent.bind(this);
    this.changeEmailAddressBoxStateEmail = this.changeEmailAddressBoxStateEmail.bind(this);
    this.changeUserNameBoxStateEmail = this.changeUserNameBoxStateEmail.bind(this);
    this.validateEmailForm = this.validateEmailForm.bind(this);
    this.resetState = this.resetState.bind(this);
    this.renderSuccess = this.renderSuccess.bind(this);
    this.renderError = this.renderError.bind(this);
    this.changeFileUpload = this.changeFileUpload.bind(this);
    this.getResponseTimeString = this.getResponseTimeString.bind(this);
    this.configFromDom = Groupon.Utils.getConfigFromDom();
    this.handleFBOrderId = this.handleFBOrderId.bind(this);
    this.isFbOrderContact = this.isFbOrderContact.bind(this);
    this.FB_ORDER_MAX_LENGTH = Groupon.Utils.getConfigFromDom().fbOrderIdMaxLength;
  }

  changeEmailDescriptionBoxState(data, isValid) {
    this.setState({
      email_description_box: data,
      email_description_box_isValid: isValid
    });
    this.validateEmailForm()
  }
  componentDidMount() {
    if (this.props.resetState) {
        var emailForm = document.getElementById("form-email");
        if (emailForm)
          emailForm.reset();
    }
    this.validateEmailForm();
  }

  changeEmailAddressBoxStateEmail(data, isValid) {
    this.setState({
      email_address_box: data,
      email_address_box_isValid: isValid
    });
    this.validateEmailForm()
  }


  changeUserNameBoxStateEmail(data, isValid) {
    this.setState({
      user_name_box: data,
      user_name_box_isValid : isValid
    });
    this.validateEmailForm()
  }

  changeFileUpload(data, name, isValid){
    this.setState({
      file_input: data,
      file_input_isValid : isValid,
      file_name: name
    });
    this.validateEmailForm()
  }
  getUserLoggedIn() {
    return JSON.parse(Groupon.Utils.getConfigFromDom().user);
  }

  validateEmailForm() {
    if (this.isRequiredInputGiven()) {
      this.enableSubmitEmail();
    }
    else {
      this.disableSubmitEmail();
    }
  }

  setRecaptchaInstance (recaptchaInstance) {
    this.recaptchaInstance = recaptchaInstance
  }

  onRecaptchaDone(instance, response) {
    if(instance)
    {
      if(response) {
        this.setState({'recaptcha': true, 'g-recaptcha-response': response})
        let data = this.getFormData()
        this.submitForm(data)
      }
      else
        this.setState({'recaptcha': false})
    }
    else
      this.setState({'recaptcha': true})
  }

  isRequiredInputGiven() {
    // if FB order contacts feature flag is enabled, there must be a fb_order_id and it must not be greater than the set length
    if(this.isFbOrderContact() && (!this.state.fb_order_id || this.state.fb_order_id.length > this.FB_ORDER_MAX_LENGTH)) {
      return false;
    }
    if (this.state.email_description_box_isValid ) {
      if (!(this.props.contactChannelParams.selectedItem) && (this.getUserLoggedIn() == null)){
        return (this.state.email_address_box_isValid && this.state.user_name_box_isValid)
      }
      return true;
    }
    return false;
  }

  onSubmitClick() {
    this.disableSubmitEmail()
    if (this.isRequiredInputGiven()) {
      if (this.configFromDom.isRecaptchaEnabled)
        this.recaptchaInstance.execute()
      else {
        let data = this.getFormData()
        this.submitForm(data)
      }
    }
    else {
      this.validateEmailForm()
    }
  }

  getFormData() {
    let data = this.setReasonText()
    var isGuestCheckoutFlow = this.props.guestOrder
    if(isGuestCheckoutFlow) {
      data.order_id = this.props.guestOrder.orderId
      data.isGuestCheckoutFlow = true
    }
    data = Helper.getBasicTicketData(data, this.props.contactChannelParams.selectedItem)
    let formdata = this.collectInputFromComponents()
    Object.assign(data, formdata)
    if (this.props.contactChannelParams.selectedItem) {
      if (this.props.contactChannelParams.selectedItem.claim_id) {
        let claimData = Helper.getClaimInfo(this.props.contactChannelParams.selectedItem)
        Object.assign(data, claimData)
      }
    }
    return data;
  }

  collectInputFromComponents() {
    let data = {}
    var user = this.getUserLoggedIn();

    data.description = "\n\n" + I18n.translate('js.modules.web_2018.quick_idea_text') + ":" + this.state.email_description_box
    data['g-recaptcha-response'] = this.state['g-recaptcha-response']
    if (user) {
      data.user_name = user.firstName;
      data.user_email = user.email;
    }
    else if (!(this.props.contactChannelParams.selectedItem)) {
      data.user_name = this.state.user_name_box;
      data.user_email = this.state.email_address_box;
    }
    data.fileData = this.state.file_input
    data.fileName = this.state.file_name
    if(this.isFbOrderContact()) {
      data.external_order_id = this.state.fb_order_id;
    }
    return data;
  }

  enableSubmitEmail() {
    var submitButton = document.getElementsByClassName('submit-button btn')[0];
    if (submitButton)
      submitButton.removeAttribute("disabled");
  }

  disableSubmitEmail() {
    var submitButton = document.getElementsByClassName('submit-button btn')[0];
    if (submitButton)
      submitButton.setAttribute('disabled', true)
  }

  submitForm(data) {
    Helper.createTicket(data, this.renderSuccess, this.renderError)
  }

  setReasonText() {
    return Helper.setReasonText(this.props.contactChannelParams)
  }

  resetState() {
    var emailForm = document.getElementById("form-email");
    if (emailForm)
      emailForm.reset();
  }

  isFbOrderContact() {
    return this.configFromDom.fbOrderContactsEnabled && this.props.contactChannelConfig 
      && this.props.contactChannelConfig.email 
      && this.props.contactChannelConfig.email.showFBOrderId;
  }

  handleFBOrderId(fb_order_id) {
    this.setState({ fb_order_id });
    this.validateEmailForm();
  }

  renderSuccess() {
    let channel;
    if (Web2018Helper.isMarketPlaceOrder(this.props.contactChannelParams.selectedItem))
      channel = "ssor_email"
    else
      channel = "email"
    this.resetState();
    route(`/customer_support/web/thank_you?channel=${channel}`);
  }

  getResponseTimeString(){
    let responseTimeString;
    if (Web2018Helper.isMarketPlaceOrder(this.props.contactChannelParams.selectedItem))
      responseTimeString = I18n.translate('js.modules.web_2018.ssor_twenty_four_hours')
    else
      responseTimeString = I18n.translate('js.modules.web_2018.twenty_four_hours')
    return responseTimeString;
  }

  renderError() {
    this.resetState();
    route(`/customer_support/web/error`);
  }

  handleClosePopupEvent(){
    this.setState({'recaptcha':false})
    this.props.handleClick()
  }

  renderFbOrderIdField() {
    return (
      <div class="fb-order-on-email-form">
        <FBInput 
          id="fb-order-id" 
          maxlength={this.FB_ORDER_MAX_LENGTH}
          label={I18n.translate('js.modules.web_2018.facebook_order_id_label')}
          value={this.state.fb_order_id} 
          valid={this.state.isValidFBId} 
          onInput={this.handleFBOrderId}/>
      </div>
    );
  }
  render() {
    var data = this.setReasonText();
    var orderSelected = this.props.contactChannelParams.selectedItem;
    var isGuestCheckoutFlow = this.props.guestOrder
    var guestDetails = {}
    if(isGuestCheckoutFlow) {
      guestDetails = {
        userName: 'Guest User',
        emailId: this.props.guestOrder.emailId,
        orderId: this.props.guestOrder.orderId
      }
    }
    var userLoggedIn = this.getUserLoggedIn();
    var isClaims = false;

    if (orderSelected )
      var isClaims = this.props.contactChannelParams.selectedItem.claim_id;

      if (userLoggedIn || orderSelected) {
         return (
           <form id="form-email">
             <div class="email-form">
              <div>
                <span class="icon-x" onClick={this.handleClosePopupEvent}></span>
              </div>
              <div className="email-us">
                {I18n.translate('js.modules.web_2018.email_us')}
              </div>
                {this.configFromDom.attachmentEnabled && 
                  <div className="attachment-text">
                    {I18n.translate('js.modules.web_2018.email_form_attachment_text')}
                  </div>
                }
              <div>
                {((!(isClaims) && orderSelected) ?
                    <MerchantNameView order={this.props.contactChannelParams.selectedItem}/> : null)}
                <IssueView reason_text={data.reasonTitle}/>
                { this.isFbOrderContact() && this.renderFbOrderIdField() }
                {this.configFromDom.attachmentEnabled && <FileInputView changeFileUploadState= {this.changeFileUpload}/>}
                <EmailFormDescriptionView changeEmailDescriptionBoxState={this.changeEmailDescriptionBoxState}/>
                {this.configFromDom.isRecaptchaEnabled && <RecaptchaView setRecaptchaInstance={this.setRecaptchaInstance} onRecaptchaDone={this.onRecaptchaDone}/>}
                {<ResponseTimeView responseTimeString={ this.getResponseTimeString()}/>}
                <EmailFormSubmitView onSubmitClick={this.onSubmitClick}/>
                <CallUsLinkView handleCallUsLink={this.props.handleCallUsLink}/>
              </div>
            </div>
           </form>
         )
      }
      else {
        return (
          <form id="form-email">
            <div class="email-form-not-logged-in">
              <div>
                <span class="icon-x" onClick={this.handleClosePopupEvent}></span>
              </div>
              <div className="email-us">
                {I18n.translate('js.modules.web_2018.email_us')}
              </div>
              {this.configFromDom.attachmentEnabled && 
                <div class="attachment-text">
                  {I18n.translate('js.modules.web_2018.email_form_attachment_text')}
                </div>
              }
              <IssueView reason_text={data.reasonTitle}/>
              <div class="user-email-info">
                <UserNameInputView changeUserNameBoxState={this.changeUserNameBoxStateEmail} guestName={guestDetails.userName}/>
                <EmailAddressInputView changeEmailAddressBoxState={this.changeEmailAddressBoxStateEmail} guestEmail={guestDetails.emailId} helpText={this.isFbOrderContact() ? I18n.translate('js.modules.web_2018.facebook_order_id_email_help_text') : null} />
              </div>
              { this.isFbOrderContact() && this.renderFbOrderIdField() }
              {this.configFromDom.attachmentEnabled && <FileInputView changeFileUploadState= {this.changeFileUpload}/>}
              <EmailFormDescriptionView changeEmailDescriptionBoxState={this.changeEmailDescriptionBoxState}/>
              {this.configFromDom.isRecaptchaEnabled && <RecaptchaView setRecaptchaInstance={this.setRecaptchaInstance} onRecaptchaDone={this.onRecaptchaDone}/>}
              {<ResponseTimeView responseTimeString={I18n.translate('js.modules.web_2018.twenty_four_hours')} />}
              <EmailFormSubmitView onSubmitClick={this.onSubmitClick}/>
              <CallUsLinkView handleCallUsLink={this.props.handleCallUsLink}/>
            </div>
          </form>
        )
      }
  }
}

module.exports = EmailFormMainView
